/** Eigenes Icon des Widget Triggers (Interface Liquid, Dot/Blob) umfärben: nur
 *  ein SVG lässt sich färben — als CSS-Maske, gefüllt mit der Icon-Farbe.
 *  Hochgeladene Icons haben keine Dateiendung (`…/image/<id>`), daher wird
 *  einmal geladen und der Typ geprüft. Ergebnis ist eine lokale Blob-URL (die
 *  Maske braucht dann keine CORS-Freigabe des Bildservers) oder null — dann
 *  bleibt es ein normales Bild in seinen Farben. Je URL nur ein Abruf.
 *  Zwei Kopien: chat-widget/…/services/icon-mask.ts und
 *  client-portal/…/pages/chat-styling/icon-mask.ts — zusammen ändern. */
const cache = new Map<string, Promise<string | null>>();

export function svgMaskUrl(url: string | null | undefined): Promise<string | null> {
  if (!url) return Promise.resolve(null);
  let hit = cache.get(url);
  if (!hit) {
    hit = loadSvg(url);
    cache.set(url, hit);
  }
  return hit;
}

async function loadSvg(url: string): Promise<string | null> {
  try {
    if (/^data:image\/svg\+xml/i.test(url)) return url;
    if (/^data:/i.test(url)) return null;
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) return null;
    const type = res.headers.get('content-type') || '';
    const text = await res.text();
    const looksSvg = /svg/i.test(type) || /^\s*(<\?xml[^>]*>\s*)?(<!--[\s\S]*?-->\s*)*<svg[\s>]/i.test(text);
    if (!looksSvg) return null;
    return URL.createObjectURL(new Blob([text], { type: 'image/svg+xml' }));
  } catch {
    return null;
  }
}
